import React from "react";
import { useAuth } from "../context/authcontext";

/**
 * Reusable RBAC guard component.
 * Conditionally renders children based on user permissions or roles.
 * 
 * @param {string} perm - Single permission required (e.g. "employee.create")
 * @param {string[]} any - Array of permissions, user needs at least ONE (e.g. ["employee.create", "employee.update"])
 * @param {string[]} all - Array of permissions, user needs ALL of them
 * @param {string} role - Required role name (e.g. "admin")
 * @param {React.ReactNode} fallback - What to render if permission check fails (defaults to null)
 * @param {React.ReactNode} children - Content to render if authorized
 */
export default function Can({ perm, any, all, role, fallback = null, children }) {
  const { hasPermission, hasAnyPermission, hasAllPermissions, hasRole } = useAuth();

  if (role && !hasRole(role)) {
    return fallback;
  }

  if (perm && !hasPermission(perm)) {
    return fallback;
  }

  if (any && Array.isArray(any) && !hasAnyPermission(any)) {
    return fallback;
  }

  if (all && Array.isArray(all) && !hasAllPermissions(all)) {
    return fallback;
  }

  return <>{children}</>;
}
